import Axios from '@/services/api/axios';
import IContext from '@/services/api/i-context';

interface IApiVideo {
}

export default class ApiRequest implements IApiVideo {

    public context: IContext;
    private http: Axios;

    public constructor(context: IContext) {
        this.context = context
        this.http = new Axios(context)
    }

    //为验证token是否过期
    public async queryLandAreaList(data: any) {
        const result = await this.http.get("/daping/base/queryLandAreaList", {
            ...data
        })
        return result
    }
    
}